import { useT } from '../../../i18n/I18nProvider';
import type { ProfileLimits } from './rules';

/**
 * Everything WhatsApp checks on a business profile, with the real limits.
 *
 * Shown under the picture so the rules are visible before anybody saves, and
 * again in a refusal WhatsApp gave no reason for, so the person has the list
 * in front of them rather than a request to try again.
 */
export function ProfileRulesList({ limits }: { limits: ProfileLimits }) {
  const t = useT();
  const mb = Math.round(limits.picture_bytes / (1024 * 1024));
  return (
    <ul className="rr-waprofile__rules">
      <li>{t('numbers.profile.rules.picture', { min: limits.picture_min_edge, size: limits.picture_edge, max: mb })}</li>
      <li>{t('numbers.profile.rules.about', { max: limits.about })}</li>
      <li>{t('numbers.profile.rules.description', { max: limits.description })}</li>
      <li>{t('numbers.profile.rules.address', { max: limits.address })}</li>
      <li>{t('numbers.profile.rules.email', { max: limits.email })}</li>
      <li>{t('numbers.profile.rules.websites', { count: limits.websites, max: limits.website })}</li>
      <li>{t('numbers.profile.rules.vertical')}</li>
    </ul>
  );
}
